function boldFormatter({ value }: { value: string | number }) {
  return <span className="font-bold">{value}</span>;
}

export default boldFormatter;
